module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "id": "pt1",
      "title": "I. Stories Not Collected Before in Book Form:"
    }
  }, [_c('p', {
    staticClass: "part_head"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xviii",
      "title": "xviii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Contents#rpt1"
    }
  }, [_vm._v("The Thurber Carnival")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fig_50"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0001-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-346ab336","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780063075771_Part_1.vue
// module id = 75
// module chunks = 0